import styled from 'styled-components';

export const DialogConsumerContentDefaultBox = styled.div<{noPadding?: boolean; disableFullscreenMobile?: boolean;}>`
    flex-grow: 1;
    padding: 0 ${({noPadding}) => noPadding ? "0" : "2rem 3rem"};
    margin: 0;
    overflow-x: auto;
    overflow-y: auto;
    background-color: ${({theme}) => theme.colors.backgroundMiddleDark };

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        padding: ${(props) => props.disableFullscreenMobile ? (props.noPadding ? "0" : "2rem 3rem") : "0"}
    }
`;
